export default "__VITE_ASSET__C_RPD1or__"